import React from 'react';
import { Checkbox} from '@material-ui/core';

export const ActionColumnFormat = (id, row, rowIndex, { onCheckbox, all }) => {
	let check = false;
	if (all.includes(id)) check = true;
	return (
		<>
			<Checkbox color="primary" checked={check} onChange={() => onCheckbox(id)} />
		</>
	);
};
